import { Container, styled } from '@mui/system';
import { Box, Card, LinearProgress, Grid2 as Grid } from '@mui/material';

export const ChatPageContainer = styled(Box)(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(12)})`,
  gap: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(2),
    gap: theme.spacing(2),
  },
}));

export const ChatsContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '100%',
    maxHeight: '680px',
  },
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
  height: '100%',

  [theme.breakpoints.down('md')]: {
    height: 620,
  },
}));

export const Progress = styled(LinearProgress)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1101,
});

export const FullHeightCard = styled(Card)({
  height: '100%',
});
